/**
 * @flow
 */

/* eslint-disable */

'use strict';

/*::
import type { ReaderFragment } from 'relay-runtime';
import type { FragmentReference } from "relay-runtime";
declare export opaque type SiteNav_viewer$ref: FragmentReference;
export type SiteNav_viewer = {|
  +showFullWidthNav: ?boolean,
  +$refType: SiteNav_viewer$ref,
|};
*/


const node/*: ReaderFragment*/ = {
  "kind": "Fragment",
  "name": "SiteNav_viewer",
  "type": "Viewer",
  "metadata": null,
  "argumentDefinitions": [],
  "selections": [
    {
      "kind": "ScalarField",
      "alias": "showFullWidthNav",
      "name": "isEnabled",
      "args": [
        {
          "kind": "Literal",
          "name": "key",
          "value": "showFullWidthNav",
          "type": "String!"
        }
      ],
      "storageKey": "isEnabled(key:\"showFullWidthNav\")"
    }
  ]
};
// prettier-ignore
(node/*: any*/).hash = '01afd52c43be255f694085d4b4fd60a3';
module.exports = node;
